import { useSelector } from 'react-redux'

import { getAvailableBoxTypes, getAvailableBoxesLoadingStatus } from 'selectors/menu-boxes/boxes'

export const useBoxes = () => {
  const boxes = useSelector(getAvailableBoxTypes)
  const isBoxesLoading = useSelector(getAvailableBoxesLoadingStatus)

  return {
    boxes,
    isBoxesLoading,
  }
}
